import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BloodApi } from '../api/blood.api';
import { switchMap, map } from 'rxjs/operators';

import { BloodData, Blood } from '../../../interfaces/masters/blood' ;
@Injectable()
export class BloodService extends BloodData {

    constructor(private api: BloodApi) {
      super();
    }
  
  
    list(url: string): Observable<Blood[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<Blood>{
        return this.api.getById(url);
    }
  
    create(url: string, data:Blood): Observable<Blood[]> {
      debugger;
      return this.api.add(url,data);
    }
  
    update(url: string, data:Blood): Observable<Blood> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  